import { EMOJI_SET } from '../../../../../_shared';

class EmojiView {

	constructor(node, view, emojiSize) {

		this.node = node;
		this.view = view;

		// Set up the emoji DOM node
		const domNode = this.node.type.spec.toDOM(this.node);

		const type = domNode[0]; // "em-emoji"
		const attrs = domNode[1]; // attrs

		if (emojiSize) {
			attrs.size = emojiSize;
		}

		// Create the emoji DOM node
		this.dom = document.createElement(type);

		this.dom.setAttribute('shortcodes', attrs.shortcodes);
		this.dom.setAttribute('set', EMOJI_SET);
		this.dom.setAttribute('size', attrs.size);

		// Copy the sanitized properties from the mark's toDOM() method
		if (attrs.id) {
			this.dom.setAttribute('id', attrs.id);
		}

		if (attrs.title) {
			this.dom.setAttribute('title', attrs.title);
		}

		if (attrs.native) {
			this.dom.setAttribute('native', attrs.native);
		}

	}

}

export default EmojiView;
